import { LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { serviceCallMixin, type ServiceCallParams } from '../../../../core/mixins/servicecall-mixin';
import { COMMAND_GET_INTERFACE, COMMAND_GET_SECTION, Response } from '../../../../core/parsers/response';

export class SectionPageBase extends serviceCallMixin(LitElement) {
  @property({ type: Object })
  params: Record<string, any> = {};

  @property({ type: String })
  title = '';

  @property({ type: Object })
  payload: any = null;

  @property({ type: String })
  service = '';

  @property({ type: Boolean })
  loading = false;

  @property({ type: Object })
  pageGroup: any = null;

  // Fix: Implement the abstract method properly
  serviceCallParams(): ServiceCallParams {
    return {
      params: this.params,
    };
  }

  private parsePayload(payload: any) {
    const response = new Response(payload);
    response.parseAll({});

    return response;
  }

  private interfaceSelector(payload: any) {
    const parsedResponse = this.parsePayload(payload);

    return parsedResponse.serviceCommands[COMMAND_GET_INTERFACE] || 
           parsedResponse.serviceCommands[COMMAND_GET_SECTION];
  }

handleResponse(response: any) {
  try {
    const x = this.interfaceSelector(response);

    // Check if response itself carries a failure status/message
    const responseStatus =
      response?.response?.response_status ??
      response?.overall_status ??
      response?.response?.overall_status;

    const responseMessage =
      response?.response?.response_message ??
      response?.response_message ??
      response?.response?.last_response ??
      response?.last_response;

    // Consider "no page groups" as failure
    const hasPageGroups = x && Array.isArray(x._pageGroups) && x._pageGroups.length > 0;

    if (!hasPageGroups) {
      const errorMessage =
        responseMessage ||
        (responseStatus && responseStatus !== '0' && responseStatus !== '00'
          ? `Service failed (status ${responseStatus})`
          : 'No page groups found in response');

      console.warn('No page groups found in response:', errorMessage);
      this.pageGroup = null;
      this.loading = false;

      // Close the dialog by bubbling up to ServicePage's _viewList handler
      this.dispatchEvent(new CustomEvent('view-list', {
        bubbles: true,
        composed: true,
        detail: { error: errorMessage, status: responseStatus }
      }));

      // Also emit a generic error event so the parent can show a snackbar
      this.dispatchEvent(new CustomEvent('service-error', {
        bubbles: true,
        composed: true,
        detail: { error: errorMessage, status: responseStatus }
      }));

      this.requestUpdate();
      return;
    }

    this.pageGroup = x._pageGroups[0];
  } catch (error) {
    console.error('Error processing response:', error);
    this.pageGroup = null;
    this.loading = false;

    this.dispatchEvent(new CustomEvent('view-list', {
      bubbles: true,
      composed: true,
      detail: { error: (error as Error)?.message || 'Unknown error' }
    }));

    this.dispatchEvent(new CustomEvent('service-error', {
      bubbles: true,
      composed: true,
      detail: { error: (error as Error)?.message || 'Unknown error' }
    }));

    this.requestUpdate();
    return;
  }

  this.loading = false;
  this.requestUpdate();
}

  _gridClasses(feed: any): string {
    if (!feed.sectionSize) {
      return 'w-full'; // Full width by default
    }

    const grids = feed.sectionSize.split('|');
    try {
      const gridValue = Math.floor(Number(grids[0]) / 2);
      
      // Map grid values to flexbox width classes
      const gridMapping: { [key: number]: string } = {
        1: 'w-full',                // Full width (100%)
        2: 'md:w-1/2',              // Half width on medium+ screens (50%)
        3: 'md:w-1/2',              // One third on medium+ screens (33.33%)
        4: 'md:w-1/2',              // One quarter on medium+ screens (25%)
        5: 'md:w-1/2',              // One fifth on medium+ screens (20%)
        6: 'md:w-1/2',              // One sixth on medium+ screens (16.66%)
        8: 'md:w-1/2',              // One eighth on medium+ screens (12.5%)
        12: 'w-full',               // Full width
      };

      // Default to full width if mapping doesn't exist
      return gridMapping[gridValue] || 'w-full';
    } catch (e) {
      console.error('Error parsing grid value:', e);
      return 'w-full';
    }
  }

  _computeTop(): number {
    return 0;
  }

  handleServiceError(error: any): void {
    this.loading = false;
    this.dispatchEvent(new CustomEvent('service-error', {
      detail: { error: error.message || 'Unknown error' },
      bubbles: true,
      composed: true
    }));
  }
}